




















import { Component, Mixins } from "vue-property-decorator";
import TexturePattern from "./TexturePattern.vue";
import {
  DraggableShapeDrawableObjectMixin
} from "./mixins";
import RectangleDragHandles from "../../../dragging/RectangleDragHandles.vue";
import { IKeyboardEventHandleable } from "..";
import { KeyCodeProcessor } from "./KeyCodeProcessor";

@Component({
  components: {
    TexturePattern,
    RectangleDragHandles,
  },
})
export default class BoxLineObject extends Mixins(
  DraggableShapeDrawableObjectMixin
) implements IKeyboardEventHandleable {
  handleKeyboardEvent(event: KeyboardEvent): boolean {
    if (!this.editingSource.isEditable) {
      return false;
    }
    const moveOffset = KeyCodeProcessor.toMoveOffset(event.keyCode);
    if (moveOffset) {
      this.writeProperty(s => s.geometry.rectangle = s.geometry.rectangle.move(moveOffset));
      return true;
    }
    return false;
  }
}
